import * as SessionStorage from "@omni/utils/sessionStorage.utils";
import { useSelector } from "react-redux";

import { Modal } from "@/components/General/Modal/modal";
import { useThunkDispatch } from "@/redux/dispatcher";
import * as CustomerModule from "@/redux/modules/api/data/customer/customer.module";
import * as CustomerSelectors from "@/redux/modules/api/data/customer/customer.selectors";
import {
    broadcastMessage,
    clearMessageById
} from "@/redux/modules/value/messages/messages.utils";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { StorageKeys } from "@/utils/enums";

import EditEmailForm from "./editEmail.component";

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

const EditEmailFormContainer = ({ onClose, isOpen }: Props) => {
    const { t } = useGranite();
    const customer = useSelector(CustomerSelectors.getCustomer);
    const isLoading = useSelector(CustomerSelectors.isLoading);
    const dispatch = useThunkDispatch();

    const onSubmit = (email: string, password: string) => {
        dispatch(CustomerModule.editEmail(email, password)).then((action) => {
            if (action.type === CustomerModule.APIStatus.SUCCESS) {
                SessionStorage.setItem(StorageKeys.CustomerEmail, email);
                onClose();
                clearMessageById("edit-email-success");
                broadcastMessage({
                    id: "edit-email-success",
                    text: t(`general.profile.editemail.modal.success`),
                    status: "success",
                    dismissible: true
                });
            } else {
                broadcastMessage({
                    id: "edit-email-failure",
                    text: t(`general.profile.editemail.modal.failure`),
                    status: "danger",
                    dismissible: false
                });
            }
        });
    };

    if (!customer) return null;

    return (
        <Modal
            open={isOpen}
            setOpen={onClose}
            formId={"profileEditEmailForm"}
            isLoading={isLoading}
            confirmButtonColor="success"
            confirmButtonText={t("general.profile.editemail.modal.submit")}
            title={t("general.profile.editemail.modal.title")}
            subtitle={t("general.profile.editemail.modal.subtitle")}
        >
            <EditEmailForm
                onSubmit={onSubmit}
                currentEmail={customer?.email}
            />
        </Modal>
    );
};

export default EditEmailFormContainer;
